// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from '../../../../../elements/Modal/Modal';
import { FormattedMessage } from 'react-intl';
import Loading from '../../../../../elements/Loading/Loading';

import buttonStyle from '../../../../../assets/styles/button.scss';
import style from './CancelModal.scss';
import classNames from 'classnames/bind';

type Props = {
  +cancelOrder: (orderId: string) => void;
  +handleClose: () => void;
  +modalVisible?: boolean;
  +isCanceling?: boolean;
  +orderId?: string;
};

export default class CancelModal extends Component<Props> {

  render() {
    const { handleClose, cancelOrder, modalVisible, isCanceling, orderId } = this.props;
    return (
      <Modal handleClose={() => !isCanceling && handleClose()}
             width={544}
             height={616}
             open={modalVisible}>
        {isCanceling && <Loading type="sk-three-bounce"
                                color="lightBlue"
                                className={style.modalLoading}
                                number={3}/>}
        {!isCanceling &&
        <section className={style.cancelOrderModal}>
          <FormattedMessage id="order.purchase.modal.cancel.title">{
            text => <h2 className={style.title}>{text}</h2>
          }</FormattedMessage>
          <FormattedMessage id="order.purchase.modal.cancel.text">{
            txt => <p>{txt}</p>
          }</FormattedMessage>
          <FormattedMessage id="order.purchase.modal.cancel.button.cancel">{
            txt => <button className={classNames(buttonStyle.btn, buttonStyle.red, style.btn)}
                           onClick={() => orderId && cancelOrder(orderId)}>{txt}</button>
          }</FormattedMessage>
          <FormattedMessage id="order.purchase.modal.cancel.button.close">{
            txt => <button className={classNames(buttonStyle.btn, buttonStyle.darkGrey, style.btn)}
                           onClick={() => handleClose()}>{txt}</button>
          }</FormattedMessage>
        </section>}

      </Modal>);
  }
}

CancelModal.propTypes = {
  cancelOrder: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  modalVisible: PropTypes.bool,
  isCanceling: PropTypes.bool,
  orderId: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/modules/order/Purchase/components/CancelModal/CancelModal.jsx